import { IRoute } from "shared/interface/types";
import { listManagementRoutes } from "./listManagementRoute";
import { taxAndAdminRoutes } from "./taxAndAdminRoute";
import { faqRoutes } from "./faqRoute";
import { couponRoutes } from "./couponRoute";
import { salePointRoutes } from "./salePointRoute";
import { featureRoutes } from "./featureRoute";
import { blogsRoutes } from "./blogsRoute";

export const ManagementRoutes: IRoute[] = [
  ...listManagementRoutes,
  ...taxAndAdminRoutes,
  ...faqRoutes,
  ...couponRoutes,
  ...salePointRoutes,
  ...featureRoutes,
  ...blogsRoutes
];
